import { render, staticRenderFns } from "./Datepicker1.vue?vue&type=template&id=4126fa69"
import script from "./Datepicker1.vue?vue&type=script&lang=js"
export * from "./Datepicker1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports